<template src="./confirm-email.html"></template>

<script>
  export default {
    name: 'ConfirmEmail',
    data () {
      return {
        email: ''
      }
    },
    created () {
      this.email = this.$route.query.email || ''
      if (!this.email) {
        this.$router.push('/login')
      }
    }
  }
</script>

<style scoped>
  .confirm-email-icon {
    margin-bottom: 0.5rem;
    text-align: center;
  }
  .confirm-email-icon .icon {
    font-size: 4rem;
    color: #4DA1FF;
  }
  .login-content hr {
    border: none !important;
    border-top: 1px solid #CED0DA !important;
    height: auto !important;
    margin: 1.5rem 0 !important;
  }
</style>
